import React from 'react';
import './Quotes.scss';
import { Stack, Typography } from '@mui/material';
import DropLetter from 'components/layout/dropLetter/DropLetter';

function Quotes() {
  return (
    <div className="quotes">
      <Stack spacing={2}>
        <Typography variant="body2" textAlign="center">
          <i>
            Speaking to yourselves in psalms and hymns and spiritual songs,
            singing and making melody in your heart to the Lord.
          </i>
        </Typography>
        <br />
        <Typography variant="body2" lineHeight={1.8}>
          <DropLetter letter="C" />
          ongregational a cappella singing was one of the identifying marks of
          the early church in the age of the apostles, and continued to be the
          standard mode of musical worship in Christian churches for the better
          part of two millennia. Using only the God-given musical instrument,
          the human voice, with the unction of the Holy Spirit to magnify God
          the Father, our ancestors in faith offered up songs of praise to our
          Lord and Savior Jesus Christ.
        </Typography>
        <Typography variant="body2" lineHeight={1.8}>
          Primitive baptists continue to follow this New Testament example.
          Congregational a capella singing of foundational hymns has always been
          an integral and identifying practice in the old Baptist worship
          service … we ever seek to “sing with the spirit and with the
          understanding also.”
        </Typography>
        <Typography variant="body2" lineHeight={1.8}>
          The Primitive Baptist Hymnal is a choice collection of psalms, hymns,
          and spiritual songs, for use in public worship, personal devotion, and
          singing schools.
        </Typography>
        <Typography variant="body2" lineHeight={1.8} textAlign="right">
          <i>– from the Foreword of the Primitive Baptist Hymnal</i>
        </Typography>
        <br />
        <Typography variant="body2" lineHeight={1.8}>
          <DropLetter letter="C" />
          lear and lovely expression of truth has been our primary consideration
          in compiling this hymnal… Our hope and prayer is that it may please
          the Lord to find this work an acceptable aid in our efforts to worship
          Him, and make it a blessing to the souls of His people.
        </Typography>
        <Typography variant="body2" lineHeight={1.8} textAlign="right">
          <i>– from the Preface of the Primitive Baptist Hymnal</i>
        </Typography>
        <br />
        <Typography variant="body2" lineHeight={1.8}>
          Visit the PBH &gt; Search page for a searchable database of the hymnal
          with MIDI recordings of each hymn.
        </Typography>
      </Stack>
    </div>
  );
}

export default Quotes;
